<template>
  <b-container fluid>
    <b-row>
      <b-col class="p-4">
        <h2 class="text-left">{{type}}s
          <span class="float-right">
            <add-course-users-form v-on:ok="addUsers" :text="'Add ' + type + 's'"></add-course-users-form>
          </span>
        </h2>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="p-4">
        <b-input-group>
          <b-form-input
            v-model="searchText"
            placeholder="Search"
            type="text">
          </b-form-input>
          <b-input-group-append>
            <b-button v-on:click="searchText = ''"><b-icon-x></b-icon-x></b-button>
          </b-input-group-append>
        </b-input-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="text-left">
        <b-button size="sm" variant="link" @click="selectAllRows" :disabled="users.length === 0">Select all</b-button>
        <b-button size="sm" variant="link" @click="clearSelected" :disabled="selectedRows.length === 0">Clear selected</b-button>
        <b-button size="sm" variant="link" @click="removeItems" :disabled="selectedRows.length === 0">Remove</b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="p-4">
        <b-table small
        ref="selectableTable"
        :items="filteredUsers"
        :fields="fields"
        :busy="loading"
        @row-selected="onRowSelected"
        selectable
        select-mode="range"
        class="text-left"
        responsive
        >
          <template v-slot:table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>

          <template v-slot:cell(user.name)="data">
            <b-button :to="{ name: 'User', params: { id: data.item.user.id}}" variant="link">{{data.value}}</b-button>
          </template>

          <template v-slot:cell(attendance)="data">
            <div class="text-danger" v-if="data.value === 'No Show'">
              {{data.value}}
            </div>
            <div class="text-warning" v-if="data.value === 'Incomplete'">
              {{data.value}}
            </div>
            <div class="text-success" v-if="data.value === 'Complete'">
              {{data.value}}
            </div>
          </template>

          <template v-slot:cell(user.email)="data">
            {{data.value}}
          </template>

          <template v-slot:cell(user.company)="data">
            {{data.value}}
          </template>

          <template v-slot:cell(user.requiresPasswordReset)="data">
            <b-form-checkbox
              v-model="data.value"
              disabled
            >
            </b-form-checkbox>
          </template>

          <template v-slot:cell(isVisible)="data">
            <b-form-checkbox :id="'cb-' + data.item.user.id + data.item.type" v-model="data.item.isVisible" @input="onIsVisibleChanged(data.item)"></b-form-checkbox>
          </template>

          <template v-slot:cell(sortOrder)="data">
            <b-form-spinbutton :id="'sb-' + data.item.user.id + data.item.type" v-model="data.item.sortOrder" min="0" max="100" @input="onSortOrderChanged(data.item)"></b-form-spinbutton>
          </template>

          <template v-slot:cell(user.disabled)="data">
            <b-form-checkbox
              v-model="data.value"
              disabled
            >
            </b-form-checkbox>
          </template>

          <template v-slot:cell(actions)="data">
            <b-button variant="link" @click="deleteUser(data.item)">Remove</b-button>
            <b-button variant="link" @click="sendCourseEmail(data.item.user.id)" :disabled="loading">Send Email</b-button>
          </template>
        </b-table>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Api from '@/api/Api'
import AddCourseUsersForm from './AddCourseUsersForm'

export default {
  props: [ 'id', 'type' ],
  data () {
    return {
      loading: false,
      users: [],
      searchText: '',
      selectedRows: []
    }
  },
  computed: {
    filteredUsers () {
      return this.searchText
        ? this.users.filter(item => item.user.name.includes(this.searchText) || item.user.email.includes(this.searchText) || (item.user.company != null ? item.user.company.includes(this.searchText) : false))
        : this.users
    },
    fields () {
      const fields = [
        {
          key: 'user.name', label: 'Name'
        },
        {
          key: 'user.email', label: 'Email'
        },
        {
          key: 'user.company', label: 'Company'
        },
        'type',
        {
          key: 'attendance', label: 'Attendance'
        },
        'disabled',
        {
          key: 'sortOrder', label: 'Sort Order'
        },
        {
          key: 'isVisible', label: 'Is Visibile'
        },
        {
          key: 'user.requiresPasswordReset', label: 'Requires Password Reset'
        },
        {
          key: 'actions', label: ''
        }
      ]
      if (this.type === 'Instructor') {
        return fields
      } else {
        return fields.filter(x => x.key !== 'isVisible' && x.key !== 'sortOrder')
      }
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    loadData () {
      var vm = this
      vm.loading = true
      Api().get(`Course/${vm.id}/Users?type=${vm.type}`)
        .then((r) => {
          vm.users = r.data
        })
        .catch((e) => {
          console.log(e)
        })
        .finally(() => {
          vm.loading = false
        })
    },
    addUsers (result) {
      var vm = this
      if (vm.type === 'Instructor' && !result.every(i => i.roles.includes('Instructor'))) {
        this.$bvModal.msgBoxOk('The user has not been assigned the Instructor Role.')
        return
      }
      vm.loading = true
      Api().post(`Course/${vm.id}/Users`, result.map((i) => { return { userId: i.id, type: vm.type } }))
        .then((r) => {
          return Api().get(`Course/${vm.id}/Users?type=${vm.type}`)
            .then((r2) => {
              vm.users = r2.data
            })
        })
        .catch((e) => {
          console.log(e)
        })
        .finally(() => {
          vm.loading = false
        })
    },
    deleteUser (user) {
      var vm = this
      this.$bvModal.msgBoxConfirm('Are you sure you want to remove this user?', {
        title: 'Remove User from Class',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
        .then(value => {
          if (value) {
            vm.loading = true
            Api().delete(`Course/${vm.id}/Users`, { data: [ user.user.id ] })
              .then((r) => {
                return Api().get(`Course/${vm.id}/Users?type=${vm.type}`)
              })
              .then((r) => {
                vm.users = r.data
              })
              .catch((e) => {
                console.log(e)
              })
              .finally(() => {
                vm.loading = false
              })
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    onRowSelected (items) {
      this.selectedRows = items
    },
    selectAllRows () {
      this.$refs.selectableTable.selectAllRows()
    },
    clearSelected () {
      this.$refs.selectableTable.clearSelected()
    },
    removeItems () {
      var vm = this
      vm.loading = true
      const ids = vm.selectedRows.map((i) => { return i.user.id })
      Api().delete(`Course/${vm.id}/Users`, { data: ids })
        .then(() => {
          vm.loadData()
        })
        .catch((e) => {
          console.log(e)
        })
    },
    sendCourseEmail (userId) {
      var vm = this
      vm.loading = true
      Api().post(`Mail/SendCourseEmail/${userId}/Course/${vm.id}`)
        .then((r) => {
          vm.$bvToast.toast('Mail Sent', {
            toaster: 'b-toaster-top-center',
            variant: 'success',
            autoHideDelay: 5000
          })
        })
        .catch((e) => {
          console.log(e)
        })
        .finally(() => {
          vm.loading = false
        })
    },
    onIsVisibleChanged (e) {
      var vm = this
      Api().post(`Course/${vm.id}/Users/${e.user.id}/Visibility`, `${e.isVisible}`, { headers: { 'Content-Type': 'application/json' } })
        .catch((e) => {
          console.log(e)
        })
    },
    onSortOrderChanged (e) {
      var vm = this
      Api().post(`Course/${vm.id}/Users/${e.user.id}/SortOrder`, `${e.sortOrder}`, { headers: { 'Content-Type': 'application/json' } })
        .catch((e) => {
          console.log(e)
        })
    }
  },
  components: {
    AddCourseUsersForm
  }
}
</script>

<style>

</style>
